module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.totalDeRegistros > 0 || _vm.exibirSemRegistros) ? _c('div', {
    staticClass: "paginacao paginacao_cor-terciaria u-margem-superior-media",
    attrs: {
      "role": "navigation",
      "aria-label": "Paginação"
    }
  }, [_c('p', {
    staticClass: "paginacao__info"
  }, [_vm._v(_vm._s(_vm.faixaDeRegistros))]), _vm._v(" "), _c('div', {
    staticClass: "paginacao__container"
  }, [_c('p', {
    staticClass: "paginacao__info"
  }, [_vm._v("\n      Página " + _vm._s(_vm.paginaAtual) + " de " + _vm._s(_vm.totalDePaginas) + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "paginacao__lista"
  }, [_c('li', {
    staticClass: "paginacao__item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.irParaPrimeiraPagina()
      }
    }
  }, [_c('a', {
    staticClass: "paginacao__navegacao paginacao__navegacao_esquerda",
    attrs: {
      "title": "Voltar para primeira página",
      "aria-disabled": !_vm.possuiPaginaAnterior,
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "paginacao__icone far fa-arrow-to-left"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "paginacao__item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.voltarParaPaginaAnterior()
      }
    }
  }, [_c('a', {
    staticClass: "paginacao__navegacao paginacao__navegacao_esquerda",
    attrs: {
      "title": "Voltar para página anterior",
      "aria-disabled": !_vm.possuiPaginaAnterior,
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "paginacao__icone far fa-arrow-left"
  })])]), _vm._v(" "), _vm._l((_vm.paginasDoIntervalo), function(pagina) {
    return _c('li', {
      staticClass: "paginacao__item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.irParaPagina(pagina)
        }
      }
    }, [(pagina != _vm.paginaAtual) ? _c('a', {
      staticClass: "paginacao__link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(pagina))]) : _vm._e(), _vm._v(" "), (pagina == _vm.paginaAtual) ? _c('a', {
      staticClass: "paginacao__link",
      attrs: {
        "href": "#",
        "aria-current": "page"
      }
    }, [_vm._v(_vm._s(pagina))]) : _vm._e()])
  }), _vm._v(" "), _c('li', {
    staticClass: "paginacao__item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.irParaProximaPagina()
      }
    }
  }, [_c('a', {
    staticClass: "paginacao__navegacao paginacao__navegacao_direita",
    attrs: {
      "title": "Ir para próxima página",
      "aria-disabled": !_vm.possuiProximaPagina,
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "paginacao__icone far fa-arrow-right"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "paginacao__item",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.irParaUltimaPagina()
      }
    }
  }, [_c('a', {
    staticClass: "paginacao__navegacao paginacao__navegacao_direita",
    attrs: {
      "title": "Ir para última página",
      "aria-disabled": !_vm.possuiProximaPagina,
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "paginacao__icone far fa-arrow-to-right"
  })])])], 2)])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b21923a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b21923a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Paginacao.vue
// module id = 1103
// module chunks = 1